(function () {

    function counter() {
        // console.log(div)
            var hePintado = false;
            var selfDiv = this;

            selfDiv.isScrolledIntoView = function (elem) {
                var elemTop = elem.getBoundingClientRect().top;
                var elemBottom = elem.getBoundingClientRect().bottom;

                var docViewTop = window.scrollY;
                var docViewBottom = docViewTop + window.innerHeight;

                return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
            };

            selfDiv.init = function () {
                var text = selfDiv.textContent;
                var newHtml = [];
                for (var cont = 0; cont < text.length; cont++) {
                    var num = text[cont];
                    if (!isNaN(num)) {
                        newHtml.push("<span class='counter_number'><span class='counter_number_inner' data-value='" + num + "'>0<br/>1<br/>2<br/>3<br/>4<br/>5<br/>6<br/>7<br/>8<br/>9<br/>0<br/>1<br/>2<br/>3<br/>4<br/>5<br/>6<br/>7<br/>8<br/>9</span></span>");
                    } else {
                        newHtml.push("<span class='counter_'>" + num + "</span>");
                    }
                }
                selfDiv.innerHTML = newHtml.join("");
                selfDiv.pintoono();
            };

            selfDiv.pintoono = function () {
                if (selfDiv.isScrolledIntoView(selfDiv) && !hePintado) {
                    selfDiv.draw();
                }
            };

            window.addEventListener("scroll", function () {
                selfDiv.pintoono();
            });

            selfDiv.draw = function () {
                hePintado = true;
                setTimeout(function () {
                    var counterNumbers = selfDiv.querySelectorAll(".counter_number_inner");
                    counterNumbers.forEach(function (selftwo) {
                        var num_c = selftwo.getAttribute("data-value");
                        var rand = Math.floor((Math.random() * 9) + 0);

                        if (num_c == 0) {
                            selftwo.style.transitionDelay = "0." + rand + "s";
                            selftwo.style.transform = "translateY(-50%) translateZ(0)";
                        } else {
                            selftwo.style.transitionDelay = "0." + rand + "s";
                            selftwo.style.transform = "translateY(-" + ((num_c * 10) / 2) + "%) translateZ(0)";
                        }
                    });
                }, 100);
            };

            selfDiv.init();
      
    }

    // Asignar la función al prototipo de Window
    window.counter = function (elements) {
        elements.forEach(function (el) {
            el.counter = counter;
            el.counter();
        });
    };

})();
